// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3xy1X","icon":"SortAdornment_icon__3k5Tr","up":"SortAdornment_up__SyVrC","down":"SortAdornment_down__3i_uV","active":"SortAdornment_active__IMFEo"};